// hooks/useMedicalHistoryUpload.js
import { useState } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import { USER_BASE_URL, MEDICAL_HISTORY } from "../../API";

export const useMedicalHistoryUpload = (TOKEN, getPastHistory, onSuccess) => {
    const [show, setShow] = useState(false);
    const [medicalFile, setMedicalFile] = useState(null);
    const [age, setAge] = useState("");
    const [gender, setGender] = useState("");
    const [error, setError] = useState("");
    const [uploading, setUploading] = useState(false);

    const toggleShow = () => setShow(prev => !prev);

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (!file) return;
        if (file.type !== "application/pdf") {
            setError("Only PDF files are allowed.");
            setMedicalFile(null);
            return;
        }
        setError("");
        setMedicalFile(file);
    };

    const uploadMedicalHistory = async () => {
        if (!medicalFile) return setError("Please upload a PDF file.");
        if (!age) return setError("Please enter your age.");
        if (!gender) return setError("Please select your gender.");

        try {
            setUploading(true);
            const formData = new FormData();
            formData.append("past_medical_history", medicalFile);
            formData.append("age", age);
            formData.append("gender", gender);

            const response = await axios.post(USER_BASE_URL + MEDICAL_HISTORY, formData, { headers: { token: TOKEN, "Content-Type": "multipart/form-data" } });

            if (response.data.code === 200) {
                getPastHistory();
                toggleShow();
                toast.success(response.data.message);
                onSuccess?.();
            }
        }
        catch (error) { setError("Upload failed. Please try again.") }
        finally { setUploading(false) }
    };

    return {
        show,
        age,
        gender,
        error,
        uploading,
        medicalFile,
        setAge,
        setGender,
        toggleShow,
        setShow,
        handleFileChange,
        uploadMedicalHistory
    };
};